import { useEffect, useState } from 'react'

export function useCountdown(totalSeconds: number) {
  const [remaining, setRemaining] = useState(totalSeconds)

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => (prev <= 1 ? totalSeconds : prev - 1))
    }, 1000)
    return () => window.clearInterval(id)
  }, [totalSeconds])

  const pad = (value: number) => String(value).padStart(2, '0')
  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor((remaining % 3600) / 60)),
    seconds: pad(remaining % 60),
  }
}
